import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";

/**
 * 正则校验操作模块
 * @module reg
 */

/**
 * 校验邮箱的正则表达式
 * @constant {RegExp}
 */
export var $emailReg = /^[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)+$/i;
/**
 * 校验手机号的正则表达式
 * @constant {RegExp}
 */

export var $telReg = /^(11|12|13|14|15|16|17|18|19)[0-9]{9}$/;
/**
 * 校验身份证的正则表达式
 * @constant {RegExp}
 */

export var $idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
/**
 * 校验银行卡的正则表达式
 * @constant {RegExp}
 */

export var $bankCardReg = /^\d{16,19}$/;
/**
 * 校验 url 地址的正则表达式
 * @constant {RegExp}
 */

export var $urlReg = /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
/**
 * 校验图片 src 地址的正则表达式
 * @constant {RegExp}
 */

export var $srcReg = /^(https?:)?\/\/|data:image|\.(jpg|png|jpeg|gif|webp|bmp)$/i;
/**
 * 检测是否合法的邮箱格式
 * @method isEmail
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$emailReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isEmail(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $emailReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的手机格式
 * @method isTel
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$telReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isTel(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $telReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的身份证号码
 * @method isIdCard
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$idCardReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isIdCard(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $idCardReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的银行卡号码
 * @method isBankCard
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$bankCardReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isBankCard(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $bankCardReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的 url 地址
 * @method isUrl
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$urlReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isUrl(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $urlReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的图片 src 地址
 * @method isSrc
 * @param {String} val 字符串
 * @param {RegExp} [regExp=$srcReg] 自定义正则表达式
 * @return {Boolean}
 */

export function isSrc(val) {
  var regExp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $srcReg;
  return typeof val === 'string' && regExp.test(val);
}
/**
 * 检测是否合法的 date 对象
 * @method isDate
 * @param {Date} date date 对象
 * @return {Boolean}
 */

export function isDate(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
}
export default {
  $emailReg: $emailReg,
  $telReg: $telReg,
  $idCardReg: $idCardReg,
  $bankCardReg: $bankCardReg,
  $urlReg: $urlReg,
  $srcReg: $srcReg,
  isEmail: isEmail,
  isTel: isTel,
  isIdCard: isIdCard,
  isBankCard: isBankCard,
  isUrl: isUrl,
  isSrc: isSrc,
  isDate: isDate
};